module.exports = __webpack_public_path__ + "static/media/broken-robot.26e53a15.svg";